var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSquare52AError = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 56 58",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M41.951 20.151a2.5 2.5 0 0 1-3.061-1.768L36.043 7.758a2.5 2.5 0 0 1 1.767-3.062l9.66-2.588a2.5 2.5 0 0 1 3.062 1.768L53.379 14.5a2.5 2.5 0 0 1-1.768 3.062l-9.66 2.588Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M43.401 19.762a1 1 0 0 1 .707-1.224l7.245-1.942a1.5 1.5 0 0 0 1.06-1.837L49.567 4.134a1.5 1.5 0 0 0-1.838-1.06l-7.244 1.94a1 1 0 0 1-.518-1.931l7.245-1.941a3.5 3.5 0 0 1 4.286 2.475l2.847 10.625a3.5 3.5 0 0 1-2.474 4.286l-7.245 1.942a1 1 0 0 1-1.225-.708Z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M37.81 53.304a2.5 2.5 0 0 1-1.767-3.062l2.847-10.625a2.5 2.5 0 0 1 3.061-1.768l9.66 2.588a2.5 2.5 0 0 1 1.768 3.062L50.53 54.124a2.5 2.5 0 0 1-3.061 1.768l-9.66-2.588Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M39.26 53.692a1 1 0 0 1 1.225-.707l7.245 1.941a1.5 1.5 0 0 0 1.837-1.06l2.847-10.626a1.5 1.5 0 0 0-1.061-1.837l-7.245-1.94a1 1 0 0 1 .518-1.933l7.245 1.942a3.5 3.5 0 0 1 2.474 4.286l-2.847 10.625a3.5 3.5 0 0 1-4.286 2.475l-7.245-1.94a1 1 0 0 1-.707-1.226Z",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M13.694 38.333a2.5 2.5 0 0 1 2.5 2.5V52.5a2.5 2.5 0 0 1-2.5 2.5h-10a2.5 2.5 0 0 1-2.5-2.5V38.333h12.5ZM13.694 20.666a2.5 2.5 0 0 1 2.5 2.5v11.667a2.5 2.5 0 0 1-2.5 2.5h-12.5V20.666h12.5ZM13.694 3a2.5 2.5 0 0 1 2.5 2.5v11.666a2.5 2.5 0 0 1-2.5 2.5h-12.5V5.5a2.5 2.5 0 0 1 2.5-2.5h10Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M12.193 55a1 1 0 0 1-1 1h-7.5a3.5 3.5 0 0 1-3.5-3.5v-47a3.5 3.5 0 0 1 3.5-3.5h7.5a1 1 0 0 1 0 2h-7.5a1.5 1.5 0 0 0-1.5 1.5v47a1.5 1.5 0 0 0 1.5 1.5h7.5a1 1 0 0 1 1 1Z",
  clipRule: "evenodd"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M34 44.542c0 .805-.653 1.458-1.458 1.458H21.458A1.458 1.458 0 0 1 20 44.542V33.458c0-.805.653-1.458 1.458-1.458h11.084c.805 0 1.458.653 1.458 1.458v11.084Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M32 44V34H22v10h10Zm.542 2c.805 0 1.458-.653 1.458-1.458V33.458c0-.805-.653-1.458-1.458-1.458H21.458c-.805 0-1.458.653-1.458 1.458v11.084c0 .805.653 1.458 1.458 1.458h11.084Z",
  clipRule: "evenodd"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M34 24.542c0 .805-.653 1.458-1.458 1.458H21.458A1.458 1.458 0 0 1 20 24.542V13.458c0-.805.653-1.458 1.458-1.458h11.084c.805 0 1.458.653 1.458 1.458v11.084Z"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M32 24V14H22v10h10Zm.542 2c.805 0 1.458-.653 1.458-1.458V13.458c0-.805-.653-1.458-1.458-1.458H21.458c-.805 0-1.458.653-1.458 1.458v11.084c0 .805.653 1.458 1.458 1.458h11.084Z",
  clipRule: "evenodd"
})));
SvgSquare52AError.viewBox = '0 0 56 58';
const ForwardRef = /*#__PURE__*/forwardRef(SvgSquare52AError);
export default ForwardRef;